import React, { memo, useRef, useState } from "react";

import { range, getClass } from "src/utils";

import styles from "./style.css";

export const Carousel = memo(props => {
  const { children, scroll = 1, show = 4, infinite = false } = props;

  const childCount = children.length;
  const shownCount = Math.min(show, childCount);
  const dotCount = 1 + Math.ceil((childCount - shownCount) / scroll);

  const carousel = useRef(null);

  const [x, setX] = useState(null);
  const [index, setIndex] = useState(0);
  const [swiping, setSwiping] = useState(false);

  const grab = e => {
    setX(e.clientX);
    !swiping && setSwiping(true);
  };

  const swipe = e => {
    if (swiping) {
      const { width } = carousel.current.getBoundingClientRect();

      const dx = e.clientX - x;
      const dir = Math.sign(dx);

      if (Math.abs(dx) > width * 0.1) {
        const swipeR = index > 0 || dir < 0;
        const swipeL = index < dotCount - 1 || dir > 0;

        if (swipeL && swipeR) {
          setIndex(index - dir);
        } else if (infinite) {
          setIndex(dir < 0 ? 0 : dotCount - 1);
        }
      }
    }
    swiping && setSwiping(false);
  };

  const childWidth = 100 / shownCount;
  const containerWidth = childCount * childWidth;
  const translate = scroll * ((-100 * index) / childCount);

  return (
    <div class={styles.wrapper}>
      <div
        ref={carousel}
        class={getClass(styles.container, swiping && styles.swiping)}
        onPointerDown={grab}
        onPointerUp={swipe}
        onPointerMove={e => e.preventDefault()}
        style={{
          width: `${containerWidth}%`,
          transform: `translate(${translate}%)`
        }}
      >
        {React.Children.map(children, child => React.cloneElement(child, { style: { ...child.props.style, width: `${childWidth}%` } }))}
      </div>
      <div class={styles.indicator}>
        {dotCount > 1 && range(dotCount).map(k => <div key={k} class={index === k ? styles.active : null} onPointerDown={() => setIndex(k)} />)}
      </div>
    </div>
  );
});
